import { Link, useNavigate } from "react-router-dom";

import { Space, Breadcrumb, Button, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PageHeader } from "@ant-design/pro-layout";

import {
  UserData,
} from "../../model/model";

import type { GetPageCallbackFunc } from "../../components/DataTable";
import DataTable from "../../components/DataTable";

import SessionStore from "../../model/SessionStore";

function ListUsers() {

  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const columns: ColumnsType<UserData> = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text, record) => <Link to={`/user/${record.login}`}>{text}</Link>,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 150,
      render: (text, record) => {
          return record.name;
      },
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      width: 150,
      render: (text, record) => {
          return record.role;
      },
    },
  ];

  const getPage = (limit: number, offset: number, callbackFunc: GetPageCallbackFunc) => {
    console.log('list users');
    SessionStore.getClient().getAllUsers(SessionStore.getBearer()).then((resp) => {
        callbackFunc(resp.data.length, resp.data);
    }).catch(err=>{
      if(err.status == 401){
          navigate(`/login`);
        }else{
          messageApi.open({
            type: 'error',
            content: err.message,
          });
        }
    });
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Network Server</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Users</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Users"
        extra={[
          <Button type="primary">
            <Link to="/users/create">Add user</Link>
          </Button>,
        ]}
      />
      <DataTable columns={columns} getPage={getPage} rowKey="id" />
    </Space>
  );
}

export default ListUsers;
